import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AuthContext from '../../AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUsers, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { logout } from '../Login/auth';

export default function Settings() {
  const { user } = useContext(AuthContext);

  return (
    <div className='app-background'>
      <div className='main-shopping-container settings-page'>
        <div className='main-item-container'>
          <div className='settings-header'>
            <h2>Settings</h2>
            <div className='settings-subtitle'>{user?.email}</div>
          </div>

          <div className='settings-section'>
            <div className='settings-section-title'>Account</div>
            <div className='settings-info-row'>
              <span>Name</span>
              <strong>{user?.displayName || 'Not set'}</strong>
            </div>
            <div className='settings-info-row'>
              <span>Email</span>
              <strong>{user?.email || 'Not set'}</strong>
            </div>
          </div>

          <div className='settings-section'>
            <div className='settings-section-title'>Management</div>
            <RouterLink className='settings-action-link' to='/vault-management'>
              <FontAwesomeIcon icon={faLock} />
              <span>Vault Management</span>
            </RouterLink>
            <RouterLink className='settings-action-link' to='/users'>
              <FontAwesomeIcon icon={faUsers} />
              <span>User Management</span>
            </RouterLink>
          </div>

          <div className='settings-section'>
            <button type='button' className='settings-action-link settings-danger-action' onClick={logout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
